import axios from 'axios';
import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
} from "./actionTypes";
import { toast } from 'react-toastify';
 // Import useNavigate jika menggunakan React Router v6

const API_KEY = process.env.REACT_APP_API_KEY;
const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

console.log("BASE_URL_BE:", BASE_URL_BE);

export const loginUser = async (user, history) => {
  try {
    const loginPayload = {
      ...user,
      grant_type: 'password',
    };

    const response = await axios.post(`${BASE_URL_BE}/auth/login`, loginPayload, {
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    });


    

    history(`/verifikasi-email?secret=${response.data.data.secret}`);
    const { token, userData } = response.data;

    return {
      type: LOGIN_SUCCESS,
      payload: {
        user: userData,
        token,
      },
    };

  } catch (error) {
    console.error("Login error:", error.response?.data || error.message);

    // Ambil message dari error response (seperti "username or password is incorrect")
    const errorMessage = error.response?.data?.message || "Login gagal";
   
    toast.error(errorMessage, {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeButton: true,
      draggable: true,
    });

    // dispatch({
    //   type: API_ERROR,
    //   payload: errorMessage,
    // });

  
  }
};

// Action biasa lainnya
export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history },
});

export const logoutUserSuccess = () => ({
  type: LOGOUT_USER_SUCCESS,
  payload: {},
});

export const apiError = (error) => ({
  type: API_ERROR,
  payload: error,
});

export const socialLogin = (type, history) => ({
  type: SOCIAL_LOGIN,
  payload: { type, history },
});
